const textClampStyles = {
    overflow: {base: 'visible', sm: 'hidden'},
    display: {base: 'block', sm: '-webkit-box'},
    textOverflow: {base: 'clip', sm: 'ellipsis'},
    color: 'textColorInvert'
}

export default {
    baseStyle: {
        textContainer: {
            p: {base: 4, md: 6}
        },
        heading: {
            ...textClampStyles,
            WebkitLineClamp: 1,
            lineHeight: {base: 'normal', md: 9},
            fontSize: '2xl',
            fontWeight: 'extrabold',
            h: {base: 'auto', md: '36px'}
        },
        subHeading: {
            ...textClampStyles,
            WebkitLineClamp: 2,
            lineHeight: '6',
            mt: 2,
            h: {base: 'auto', md: '48px'}
        }
    },
    parts: ['textContainer', 'heading', 'subHeading']
}
